var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.01777 7.6361L9.63388 13.4102C10.122 13.8362 10.122 14.5269 9.63388 14.9529C9.14573 15.379 8.35427 15.379 7.86612 14.9529L0.366117 8.40749C-0.122039 7.98146 -0.122039 7.29073 0.366117 6.86471L7.86612 0.319254C8.35427 -0.106772 9.14573 -0.106772 9.63388 0.319254C10.122 0.74528 10.122 1.43601 9.63388 1.86203L3.01777 7.6361Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.f940a7fd17c5c74ba40e2116eadf5322.svg";
export { ForwardRef as ReactComponent };